// @owners { team: patients }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, Column, LgPadding, Row } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly number: number;
  readonly children: React.ReactNode;
};

export const NumberedStep = ({ number, children }: Props) => (
  <LgPadding
    topPadding={SPACING.STATIC.XXS}
    bottomPadding={SPACING.STATIC.XXS}
  >
    <Row
      top
      wrap={false}
      gap="SM"
    >
      <Body color={COLORS.TEXT_COLORS.GREY}>{number}.</Body>
      <Column
        flexShrink={1}
        flexGrow={1}
      >
        <Body color={COLORS.TEXT_COLORS.GREY}>{children}</Body>
      </Column>
    </Row>
  </LgPadding>
);
